import { useQuery } from '@tanstack/react-query';
import { fetchDealerConfigSettings } from '../services/dealerConfig';
import type { DealerConfigSettingsListParams } from '../types/dealerConfig.types';

/**
 * Own query-key factory for the per-dealer settings list — distinct from the
 * dealer-detail key (`dealerKeys.detail`) and from the catalog key
 * (`dealerConfigOptionKeys`, incl. its `.combobox()`). Settings mutations invalidate only
 * `dealerConfigSettingKeys.list(dealerId)` (plan §"Response-shape note").
 */
export const dealerConfigSettingKeys = {
    all: ['dealers', 'config-settings'] as const,
    list: (dealerId: string) => [...dealerConfigSettingKeys.all, dealerId] as const,
};

export function useDealerConfigSettingsQuery(dealerId: string, params: DealerConfigSettingsListParams = {}) {
    return useQuery({
        // `limit` is an optional caller override (max 100) on an otherwise
        // unbounded-looking list; folding it into the key keeps a
        // limit-scoped fetch from ever colliding with the default cache entry.
        queryKey: [...dealerConfigSettingKeys.list(dealerId), params],
        queryFn: () => fetchDealerConfigSettings(dealerId, params),
        enabled: !!dealerId,
    });
}
